import { baseApi } from './baseApi';
import type { LoginRequest, LoginResponse } from '../types/auth';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (body) => ({
        url: '/auth/login',
        method: 'POST',
        body,
      }),
    }),
    changePassword: builder.mutation<{ message?: string }, { current_password: string; new_password: string }>({
      query: (body) => ({
        url: '/auth/changepassword',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Auth'],
    }),
  }),
});

export const { useLoginMutation, useChangePasswordMutation } = authApi;
